import React, { useEffect, useState } from 'react';
import DropDownField from '../../../helpers/DropDownField';
import Button from '../../../helpers/Button';
import TextInputField from '../../../helpers/TextInputField';
import { AutoCompleteField, CheckboxField } from '../../../helpers';

import { confirmDialog, ConfirmDialog } from 'primereact/confirmdialog';

import { Tooltip } from 'primereact/tooltip';
import { raiseToast } from '../../../services/redux/reducers/toast/toast';
import { useDispatch } from 'react-redux';

const UnmappedProduct = (props) => {
    const { 
        productDetails, 
        index, 
        removeRequirement, 
        handleProductChange,
        brandsData, 
        industryData, 
        uomsData,
        companyERPCodeMaps, 
        orderTypeId,
        formErrors,
        products,
        setProducts,
        handleAutoFillProductData, 
        handleMoveToSectiontwo,
        handleUnmappedProductsMoves,
        requirement,
        buyerReqId
    } = props
    
    const { 
        productId, 
        materialId, 
        companyERPCode, 
        productName, 
        // variantName,
        specification, 
        brand, 
        category, 
        quantity, 
        materialUOMId, 
        uomValue, 
        buyerRateContractId, 
        isOverRiddedProduct,
        isMappedProduct,
        isMaterialMasterProduct,
        materialMasterProductName,
        materialMasterSpecification,
        isERPCodeFound,
        isMaterialIDFound,
        isValidMaterialId
    } = productDetails
    
    const [searchedMaterialBrands, setSearchedMaterialBrands] = useState([])
    const [visibleConfirmQty, setVisibleConfirmQty] = useState(false)
    const [visibleMappingConfirmation, setVisibleMappingConfirmation] = useState(false)
    const [isProductLocked, setIsProductLocked] = useState(true)
    const [materialIdEdit, setMaterialIdEdit] = useState(true)
    const [categories, setCategories] = useState([])

    useEffect(() => {
        const unknownCategory = {
            categoryId: 22,
            categoryName: "Unknown",
            createdAt: "2023-08-11T10:02:08.609Z",
            createdBy: 1,
            industryName: "Procmart",
            statusId: 2,
            updatedAt: "2023-08-11T10:02:08.609Z",
            updatedBy: 1
        }
        setCategories([...industryData, unknownCategory])

    }, [industryData])

    const dispatch = useDispatch()

    const handleChange = (e) => {
        /*if(e.target.name === "quantity") {
            if ((e.target.value).toString().length <= 6) handleProductChange(productId, e.target.name, e.target.value)
        }
        
        handleProductChange(productId, e.target.name, e.target.value)*/

        // if(e.target.name === "category" && e.target.value === "object" && e.target.value !== null){
        //     handleProductChange(productId, e.target.name, e.target.value.categoryId)
        // }
        if(e.target.name === "brand" && e.target.value === "object" && e.target.value !== null){
            handleProductChange(productId, e.target.name, e.target.value.brandId)
        }
        else{
            handleProductChange(productId, e.target.name, e.target.value)
        }
    }

    const handleUnmappedProductDelete = (productId) => {
        const newProductsList = products.filter(eachProduct => eachProduct.productId !== productId)
        setProducts([...newProductsList])
    }

    const handleStock = async (e) => {
        if(e.target.value && e.target.value.length < 6){ 
            const productData = {
                companyERPCode: "",
                materialId: e.target.name === "materialId" ? e.target.value : null,
                productName: "",
                variantName: '',
                specification: '',
                categoryId: null,
                brandId: null,
                uomValue: '',
                materialUOMId: null,
                quantity: '',
                companyERPCodeMapId: null,
                isMappedProduct: isMappedProduct,
                buyerRateContractId: null,
                isOverRiddedProduct: false
            }
            handleAutoFillProductData(productId, productData)

            if(!e.target.value && e.target.name === "materialId") dispatch(raiseToast({severity:'error',  detail: "Invalid material codde", life: 3000}))
            return
        }
        else{
            if(e.target.name === "materialId"){
                setMaterialIdEdit(true)
                if (e.target.value.toString()[0] === '7') {
                    setMaterialIdEdit(false)
                    return dispatch(raiseToast({ severity: 'error', detail: `Can't search VMI materials in regular requirement!` }))
                }
                handleUnmappedProductsMoves(productId, "", materialId)
            }
            else if(e.target.name === "companyERPCode"){
                handleUnmappedProductsMoves(productId, "", companyERPCode)
            }
        }
    }

    const handleCompanyERPCodeMapping = async (e, companyERPCodeMaps, orderTypeId) => {

        if (!e.target.value) {
            return
        }

        if (orderTypeId === 3) {
            handleStock(e)
        }

        if (e.target.name === "materialId" && e.target.value.length < 6) {
            const productData = {
                companyERPCode: "",
                materialId: null,
                productName: "",
                variantName: '',
                specification: '',
                categoryId: null,
                brandId: null,
                uomValue: '',
                materialUOMId: null,
                quantity: '',
                companyERPCodeMapId: null,
                isMappedProduct: isMappedProduct,
                buyerRateContractId: null,
                isOverRiddedProduct: false
            }
            handleAutoFillProductData(productId, productData)

            if (!e.target.value){ 
                return dispatch(raiseToast({ severity: 'error', detail: "Invalid material code", life: 3000 }))
            }
        }

        let erpCodeMatch = null
        if (orderTypeId === 1) {
            if (e.target.name === "companyERPCode") {
                erpCodeMatch = companyERPCodeMaps.find(eachErp => eachErp.companyERPCode === e.target.value)
            }
            else if (e.target.name === "materialId") {
                erpCodeMatch = companyERPCodeMaps.find(eachErp => parseInt(eachErp.materialId) === parseInt(e.target.value))
            }
        }

        if (erpCodeMatch && orderTypeId === 1) {
            const accept = () => {
                const productData = {
                    productId: productId,
                    companyERPCode: erpCodeMatch.companyERPCode,
                    materialId: erpCodeMatch.materialId,
                    productName: erpCodeMatch.companyProdName,
                    variantName: erpCodeMatch.variantName,
                    specification: erpCodeMatch.companyProdSpec,
                    categoryId: erpCodeMatch.categoryId,
                    brandId: erpCodeMatch.brandId,
                    uomValue: erpCodeMatch.UOMValue,
                    materialUOMId: erpCodeMatch.materialUOMId,
                    quantity: '',
                    companyERPCodeMapId: erpCodeMatch.companyERPCodeMapId,
                    isMappedProduct: true,
                    buyerRateContractId: null,
                    isOverRiddedProduct: false
                }

                if (!isMappedProduct) {
                    dispatch(raiseToast({ severity: 'success', detail: "Company ERP code is mappped. Product is moved to mapped products section.", life: 3000 }))
                }

                handleAutoFillProductData(productId, productData)
            }

            const reject = () => {

                let companyERPCode = null
                let materialId = null

                if(e.target.name === "companyERPCode"){
                    companyERPCode = e.target.value
                    materialId = productDetails.materialId
                }
                else{
                    materialId = e.target.value
                    if(productDetails.companyERPCode){
                        companyERPCode = productDetails.companyERPCode
                    }

                }

                const newUnMappedProduct = {
                    productId: productId,
                    companyERPCode: companyERPCode,
                    materialId: materialId,
                    productName: productDetails.productName,
                    variantName: productDetails.variantName,
                    specification: productDetails.specification,
                    categoryId: productDetails.categoryId,
                    category: productDetails.category,
                    brandId: productDetails.brandId,
                    brand: productDetails.brand,
                    uomValue: productDetails.uomValue,
                    materialUOMId: productDetails.materialUOMId,
                    quantity: null,
                    companyERPCodeMapId: null,
                    isMappedProduct: false,
                    buyerRateContractId: null,
                    isOverRiddedProduct: false
                }

                //Add tooltip

                handleAutoFillProductData(productId, newUnMappedProduct)
            }

            let erpCodeMaterialMatch = null
            if(e.target.name === "materialId"){
                erpCodeMaterialMatch = e.target.value && productDetails.companyERPCode && companyERPCodeMaps.find(eachErp => parseInt(eachErp.materialId) === parseInt(e.target.value) && eachErp.companyERPCode && eachErp.companyERPCode === productDetails.companyERPCode)
            } else if(e.target.name === "companyERPCode"){
                erpCodeMaterialMatch = materialId && e.target.value && companyERPCodeMaps.find(eachErp => parseInt(eachErp.materialId) === parseInt(materialId) && eachErp.companyERPCode && e.target.value === productDetails.companyERPCode)
            }

            if(!erpCodeMaterialMatch){
                confirmDialog({
                    message: "Mapping found for this product. Proceed with mapping?",
                    header: '',
                    icon: 'pi pi-info-circle',
                    rejectLabel: "No",
                    acceptLabel: "Yes",
                    accept,
                    reject
                })
            } else {
                accept()
            }
        }
        else {
            if (e.target.value) {
                setMaterialIdEdit(true)
                if (e.target.name === "materialId") {
                    if (e.target.value.toString()[0] === '7') {
                        setMaterialIdEdit(false)
                        return dispatch(raiseToast({ severity: 'error', detail: `Can't search VMI materials in regular requirement!` }))
                    }
                    handleUnmappedProductsMoves(productId, "", materialId)
                }
            }
            else {
                const productData = {
                    companyERPCode: '',
                    materialId: '',
                    productName: '',
                    specification: '',
                    category: null,
                    brand: null,
                    uomValue: null,
                    materialUOMId: null,
                    quantity: '',
                    isMappedProduct: false,
                    buyerRateContractId: null,
                    companyERPCodeMapId: null, //Always null
                    isOverRiddedProduct: false,
                    isMaterialMasterProduct: false
                }
                handleAutoFillProductData(productId, productData)
            }
        }
    }

    const handleProductLockChange = (e) => {
        if(e.checked){
            const updatedProducts = products.map(eachProduct => {
                if(eachProduct.productId === productId){
                    return {...eachProduct, productName: materialMasterProductName, specification: materialMasterSpecification}
                }
                return eachProduct
            })
            setProducts(updatedProducts)
        }
        setIsProductLocked(e.checked)
    }

    const handleMaterialIdPriority = (e) => {
        const updatedProducts = products.map(eachProduct => {
            if (eachProduct.productId === productId) {
                return { ...eachProduct, isHighPriority: e.checked }
            }
            return eachProduct
        })
        setProducts(updatedProducts)
    }

    const searchBrands = (event) => {
        const relatedBrand = brandsData.filter(brand => brand.brandName.toLowerCase().includes(event.query.trim().toLowerCase()))
        setSearchedMaterialBrands([...relatedBrand])
    }

    const handleAcceptClick = () => {
        setVisibleConfirmQty(false)
    }

    const handleRejectClick = () => {
        const updatedProducts = products.map(eachProduct => {
            if(eachProduct.productId === productId){
                return {...eachProduct, quantity: null}
            }
            return eachProduct
        }) 
        setProducts(updatedProducts)
        setVisibleConfirmQty(false)
    }

    const handleQuantityCheck = (e) => {
        if(e.target.name === "uomValue"){
            if(parseFloat(quantity) > 0 && parseFloat(uomValue) > 1 && (parseFloat(quantity) % parseFloat(e.target.value) === 0)){
                setVisibleConfirmQty(true)
            }
        }

        if(e.target.name === "quantity"){
            if (e.target.value === ""){
                e.target.value = 0
            }
            if (buyerReqId && parseFloat(e.target.value) < parseFloat(productDetails.existedQuantity)) {
                dispatch(raiseToast({ severity: 'error', detail: "Quantity should be more than already existed qty.", life: 3000 }))
                handleProductChange(productId, e.target.name, productDetails.existedQuantity)
                //e.target.value = productDetails.existedQuantity
            }

            if(parseFloat(uomValue) > 1 && (parseFloat(e.target.value) % parseFloat(uomValue) === 0)){
                setVisibleConfirmQty(true)
            }
        }
    }

    const handleQuantityCheckOnEnter = (e) => { //Not working, check later!
        if(e.key === "Enter"){
            handleQuantityCheck(e)
        }
    }

    const handleEditMaterialId = () => {
        setMaterialIdEdit(preVal => !preVal)

        if(materialId && !materialIdEdit){
            if(materialId.length < 6){
                const productData = {
                    companyERPCode: '',
                    materialId: '',
                    productName: '',
                    specification: '',
                    category: null,
                    brand: null,
                    uomValue: null,
                    materialUOMId: null,
                    quantity: '',
                    isMappedProduct: false,
                    buyerRateContractId: null,
                    companyERPCodeMapId: null, //Always null
                    isOverRiddedProduct: false,
                    isMaterialMasterProduct: false
                }
                handleAutoFillProductData(productId, productData)
            }
            else if(materialId.length > 5){
                if (materialId.toString()[0] === '7') {
                    setMaterialIdEdit(false)
                    return dispatch(raiseToast({ severity: 'error', detail: `Can't search VMI materials in regular requirement!` }))
                }

                let erpCodeMatch = companyERPCodeMaps.find(eachErp => parseInt(eachErp.materialId) === parseInt(materialId) && eachErp.companyERPCode && eachErp.companyERPCode === productDetails.companyERPCode)
                if(erpCodeMatch){
                    const productData = {
                        productId: productId,
                        companyERPCode: erpCodeMatch.companyERPCode,
                        materialId: erpCodeMatch.materialId,
                        productName: erpCodeMatch.companyProdName,
                        variantName: erpCodeMatch.variantName,
                        specification: erpCodeMatch.companyProdSpec,
                        categoryId: erpCodeMatch.categoryId,
                        brandId: erpCodeMatch.brandId,
                        uomValue: erpCodeMatch.UOMValue,
                        materialUOMId: erpCodeMatch.materialUOMId,
                        quantity: '',
                        companyERPCodeMapId: erpCodeMatch.companyERPCodeMapId,
                        isMappedProduct: true,
                        buyerRateContractId: null,
                        isOverRiddedProduct: false
                    }
    
                    if (!isMappedProduct) {
                        dispatch(raiseToast({ severity: 'success', detail: "Company ERP code is mappped. Product is moved to mapped products section.", life: 3000 }))
                    }
    
                    handleAutoFillProductData(productId, productData)
                    return
                }

                handleUnmappedProductsMoves(productId, "", materialId)   
            }
        }
    }

    const handleCompanyERPCodeMappingOnEnter = (e) => {
        if(e.key === "Enter"){
            handleCompanyERPCodeMapping(e, companyERPCodeMaps, orderTypeId)
        }
    }

    const overrideTooltipText = () => {
        if(isERPCodeFound && isMaterialIDFound){
            return <p>ERP Code is taken as priority. Material ID is ignored.</p>
        }

        else if(isERPCodeFound && !isMaterialIDFound){
            return <p>Product details are extracted from the sheet along with ERPCode.</p>
        }

        else if(isMaterialIDFound && isValidMaterialId){
            return <p>Valid material ID is found. Sheet details are overided.</p>
        }

        else if(isMaterialIDFound && !isValidMaterialId){
            return <p>Invalid material ID is ignored. Product details are extracted from the sheet</p>
        }

        else if(!isERPCodeFound && !isMaterialIDFound){
            return <p>Product details are extracted from the sheet</p>
        }

        else return null
    }

    const handleCopyPaste = (e) => {
        e.preventDefault()
    }

    let brandRCName = ''
    let categoryRCName = ''
    if(orderTypeId === 2){
        brandRCName = brandsData.find(eachBrand => eachBrand.brandId === brand)?.brandName
        categoryRCName = industryData.find(eachIndustry => {
            return eachIndustry.categoryId === category
        })
    }

    let brandName = ''
    if(typeof(brand) === "number"){
        brandName = brandsData.find(eachBrand => eachBrand.brandId === brand)?.brandName
    }else{ brandName = brand }
    let categoryName = ''
    // if(typeof(category) === "number"){
    //     categoryName = industryData.find(eachIndustry => eachIndustry.categoryId === category)?.categoryName
    // }else{ categoryName = category }

    const uomName = uomsData.find(eachUOM => eachUOM.materialUOMId === materialUOMId)?.UOM
    if(isMaterialMasterProduct){
        brandName = brandsData.find(eachBrand => eachBrand.brandId === brand)?.brandName
        categoryName = industryData.find(eachCategory => eachCategory.categoryId === category)?.categoryName
    }

    const disableCond = buyerRateContractId
    let materialDisabledCond = buyerRateContractId || isMaterialMasterProduct
    const productAndSpecificationCond = buyerRateContractId || (isMaterialMasterProduct && isProductLocked)
    
    let materialTooltip = ""
    if(materialMasterProductName && materialMasterSpecification && categoryName && brandName && uomValue && uomName){
        materialTooltip = `product: ${materialMasterProductName} specifications: ${materialMasterSpecification} category: ${categoryName} brand: ${brandName} uomValue: ${uomValue} uom: ${uomName} `
    }

    const allowPriorityToChange = (!materialId || (materialId && materialId.toString().length > 6)) && requirement.bussinessTypeId === 1 && [1, 2, 3].includes(requirement.orderTypeId)

    const isIncrementalReq = buyerReqId && productDetails.buyerReqItemId

    return(
        <>
            <ConfirmDialog visible={visibleConfirmQty} closable={false} message={`Are you sure you want to proceed with ${parseFloat(uomValue)} ${uomName} * ${parseFloat(quantity)} = ${parseFloat(uomValue) * parseFloat(quantity)}`} icon="pi pi-info-circle" reject={() => handleRejectClick()} accept={() => handleAcceptClick()}/>
            <tr className="custom-table-tr custom-tr product-items-table">
                <td className="custom-td">{index + 1}</td>
                <td className="custom-td"><TextInputField name="companyERPCode" value={companyERPCode} onChange={handleChange} disabled={disableCond || isIncrementalReq} onKeyDown={(e) => handleCompanyERPCodeMappingOnEnter(e, companyERPCodeMaps, orderTypeId)} onBlur={(e) => handleCompanyERPCodeMapping(e, companyERPCodeMaps, orderTypeId)}{...(orderTypeId === 3 ? {keyfilter: "pnum"} : {})} maxLength={255} /></td>
                <td className="custom-td">
                    <div className='flex align-items-center'>
                        <TextInputField name="materialId" value={materialId} placeholder={materialId} onChange={handleChange} onKeyDown={(e) => handleCompanyERPCodeMappingOnEnter(e, companyERPCodeMaps, orderTypeId)} onBlur={(e) => handleCompanyERPCodeMapping(e, companyERPCodeMaps, orderTypeId)} disabled={materialIdEdit || (buyerReqId && productDetails.buyerReqItemId)} keyfilter={"pnum"} className={`material-master-tooltip`} {...(isMaterialMasterProduct ? {tooltip: materialTooltip, tooltipOptions: { position: 'top', showOnDisabled: true }} : {})} />
                        {
                            orderTypeId !== 2 ? materialIdEdit ?
                            <i style={{ fontSize: '0.9rem' }} onClick={handleEditMaterialId} className={`custom-materialId-tooltip-btn-${productId} pi pi-file-edit ml-1 cursor-pointer`}></i> :
                            <i style={{ fontSize: '0.9rem' }} onClick={handleEditMaterialId} className={`custom-materialId-tooltip-btn-${productId} pi pi-save ml-1 cursor-pointer`}></i> : null
                        }
                        {/* <Tooltip target={`.custom-materialId-tooltip-btn-${productId}`} position='top'>
                            {
                                materialIdEdit ? <p>Edit material Id</p> : <p>Edit material Id</p>
                            }
                        </Tooltip>  */}
                    </div>
                </td>
                <td className="custom-td"><DropDownField name="category" value={category} onChange={handleChange} options={categories} optionLabel="categoryName" optionValue="categoryId" disabled={materialDisabledCond || isIncrementalReq} /></td>
                {/* <td className="custom-td"><AutoCompleteField name="category" value={buyerRateContractId ? categoryRCName : categoryName} field="categoryName" searchMethod={searchIndustry} suggestions={searchedMaterialIndustry} onChange={handleChange} forceSelection {...(buyerRateContractId ? {disabled: true} : {})} /> </td> */}
                <td className="custom-td"><AutoCompleteField name="brand" value={buyerRateContractId ? brandRCName : brandName} field="brandName" searchMethod={searchBrands} suggestions={searchedMaterialBrands} onChange={handleChange} forceSelection {...((materialDisabledCond || isIncrementalReq) ? {disabled: true} : {})} onPaste={(e)=>handleCopyPaste(e)} /> </td>
                <td className="custom-td"><TextInputField name="productName" value={productName} onChange={handleChange} {...(buyerRateContractId ? {tooltip: productName, tooltipOptions: { position: 'top', showOnDisabled: true }} : {})} disabled={productAndSpecificationCond || isIncrementalReq} maxLength={250} /> </td>
                <td className="custom-td"><TextInputField name="specification" value={specification} onChange={handleChange} {...(buyerRateContractId ? {tooltip: specification, tooltipOptions: { position: 'top', showOnDisabled: true }} : {})} disabled={productAndSpecificationCond || isIncrementalReq} maxLength={255} /></td>
                <td className="custom-td"><TextInputField name="uomValue" value={uomValue} onChange={handleChange} keyfilter={"pnum"} disabled={materialDisabledCond || isIncrementalReq} onBlur={handleQuantityCheck} onKeyDown={handleQuantityCheckOnEnter} /></td>
                <td className="custom-td"><DropDownField name="materialUOMId" value={materialUOMId} onChange={handleChange} keyfilter={"pnum"} options={uomsData} optionLabel="UOM" optionValue="materialUOMId" disabled={materialDisabledCond || isIncrementalReq} /></td>
                <td className="custom-td"><TextInputField name="quantity" value={quantity} onChange={handleChange} keyfilter={"pnum"} disabled={materialUOMId ? false : true} onBlur={handleQuantityCheck} onKeyDown={handleQuantityCheckOnEnter} /></td>
                <td><div className='flex justify-content-center'>{isMaterialMasterProduct && <CheckboxField checked={isProductLocked} onChange={handleProductLockChange} />}</div></td>
                <td><div className='flex justify-content-center'>{allowPriorityToChange && <CheckboxField checked={productDetails.isHighPriority} onChange={handleMaterialIdPriority} disabled={category === 22} />}</div></td>
                <td className="custom-td"><Button className="decrement-btn-icon" icon="pi pi-times-circle" text onClick={() => handleUnmappedProductDelete(productId)} disabled={((buyerReqId && productDetails.buyerReqItemId)) ? true : false}/></td>
                {   isOverRiddedProduct ?
                    <>
                        <td className="custom-td"><Button className={`custom-tooltip-btn-${productId} cursor-auto`} severity="warning" icon="pi pi-exclamation-circle" text /></td>
                        <Tooltip target={`.custom-tooltip-btn-${productId}`} position='top'>
                            {overrideTooltipText()}
                        </Tooltip> 
                    </>
                : null}
            </tr>
        </>
    )
}

export default UnmappedProduct